function get(path, obj) {
    return path.split('.').reduce(function (res, key) { return res[key] || ''; }, obj);
}
function parseTpl(template, map) {
    return template.replace(/\$\{.+?}/g, function (match) {
        var path = match.substring(2, match.length - 1).trim();
        return get(path, map);
    });
}
export default parseTpl;
//# sourceMappingURL=parseStringTemplate.js.map